import { Checkbox, Spinner } from "@chakra-ui/react"
import { useState } from "react"
import { api } from "../../../services/api"

export function CheckItem({ item, validacao_frete, refresh, isChecked }) {
  const [loading, setLoading] = useState()

  async function updateItem(numero_nota, validacao_frete) {
    setLoading(true)

    try {
      await api.post('/site/v2/crm-controle/valida-fechamento-frete', {
        numero_nota,
        validacao_frete
      })

      refresh()

      setLoading(false)

    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }



return (
  <>
    {!loading && (
      <Checkbox 
        onChange={(e) => updateItem(item.nunota, validacao_frete)}
        isChecked={isChecked}
        borderColor="blue.500"
      />  
    )}  
    {loading && (
      <Spinner size="sm" />
    )}
  </>
)

}